import { Observable } from "rxjs";
import moment from "moment";
import * as http from "../../../../../services/http.service";

import { IFlyerDetailData } from "../../../types/flyer-detail-data/flyer-detail-data.interface";
import { FlyerDetailForm } from "../types/flyer-detail-form/flyer-detail-form.interface";

export function exportPageEndPoint(pageId: number): string {
  return `/pages/${pageId}/export/`;
}

export function fetchFlyer(id: number): Observable<IFlyerDetailData> {
  return http.get(endPoint(id));
}

export function saveFlyer(form: FlyerDetailForm): Observable<IFlyerDetailData> {
  const payload = mapFormToRequestPayload(form);
  return http.patch(endPoint(form.id!), payload);
}

export function changeName(flyerId: number, name: string): Observable<IFlyerDetailData> {
  return http.patch<IFlyerDetailData>(endPoint(flyerId), { name });
}

export function deletePage(pageId: number): Observable<void> {
  if (!pageId || isNaN(pageId)) {
    throw new Error(`Invalid pageId: ${pageId}`);
  }

  return http.del(`pages/${pageId}`);
}

const mapFormToRequestPayload = (form: FlyerDetailForm): Partial<IFlyerDetailData> => {
  return {
    flyerFormat: form.format,
    overview: form.overview,
    regions: form.regions,
    wtwReviewDate: moment(form.wtwReviewDate).format("YYYY-MM-DD"),
    wtwSeniorReviewDate: moment(form.wtwSeniorReviewDate).format("YYYY-MM-DD"),
    paginationStatus: form.paginationStatus === "1",
    startAt: moment(form.startAt).format("YYYY-MM-DD"),
    endAt: moment(form.endAt).format("YYYY-MM-DD"),
  };
};

function endPoint(id: number): string {
  return `/flyers/${id}/`;
}
